import {PureComponent, Component} from "react"
import {FetchPolicy} from "@apollo/client"

export interface RefetchProps {
  fetchPolicy?: FetchPolicy
}

export interface RefetchState {
  fetchPolicy?: FetchPolicy
}

export type Self = PureComponent<RefetchProps, RefetchState> | Component<RefetchProps, RefetchState>

export default class RefetchOnMount {
  self: Self

  constructor(self: Self) {
    this.self = self
    if (!this.self.state) {
      this.self.state = {}
    }
  }

  static onUpdate(props: RefetchProps, state: RefetchState) {
    if (props.fetchPolicy) {
      return {fetchPolicy: props.fetchPolicy}
    }

    if (!state.fetchPolicy) {
      return {fetchPolicy: "network-only"}
    }

    return {}
  }

  didMount() {
    if (!this.self.props.fetchPolicy) {
      this.self.setState({fetchPolicy: "cache-first"})
    }
  }
}
